import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const ApplicationIntelligenceNotAvailableForThisApplication = () => {
  return (
    <footer className="border-t border-alpha-40 px-6 gap-2 flex items-center h-[72px]">
      <HugeiconsIcon
        icon={InformationCircleIcon}
        className="text-content-100"
        size={16}
      />
      <p className="text-content-200 font-medium text-sm">
        Application Intelligence not available for this application
      </p>
    </footer>
  );
};
